const forbidden = /[\u0000-\u001F\u007F/\\?#%]/u;
const visibleControl = /[\u0000-\u001F\u007F]/u;
const accessCodePattern = /^[0-9]{6}$/;
export const SHORT_CODE_ALPHABET = 'abcdefghijkmnopqrstuvwxyz23456789';
const shortCodePattern = new RegExp(`^[${SHORT_CODE_ALPHABET}]{4}$`, 'i');
const canonicalShortCodePattern = new RegExp(`^[${SHORT_CODE_ALPHABET}]{4}$`);
const reservedRootPaths = new Set([
  'api',
  '_next',
  '_vercel',
  'admin',
  'ca',
  'custom',
  'rooms',
  'zh',
  'ja',
  'en',
]);

function codePoints(value: string) {
  return [...value].length;
}

export function normalizeRoomName(input: string): string {
  return input.trim().normalize('NFKC').replace(/\s+/gu, ' ').toLocaleLowerCase();
}

export function validateRoomName(input: unknown): string | undefined {
  if (typeof input !== 'string') return undefined;
  const value = input.trim().normalize('NFC');
  if (
    !value ||
    codePoints(value) > 80 ||
    new TextEncoder().encode(value).byteLength > 255 ||
    forbidden.test(value)
  )
    return undefined;
  return value;
}

export function validateParticipantName(input: unknown): string | undefined {
  if (typeof input !== 'string') return undefined;
  const value = input.trim().normalize('NFC');
  if (!value || codePoints(value) > 50 || visibleControl.test(value)) return undefined;
  return value;
}

export function isAccessCode(input: unknown): input is string {
  return typeof input === 'string' && accessCodePattern.test(input);
}

export function isShortCode(input: unknown): input is string {
  return getCanonicalShortCode(input) !== undefined;
}

export function isCanonicalShortCode(input: unknown): input is string {
  return (
    typeof input === 'string' && canonicalShortCodePattern.test(input) && !isReservedRootPath(input)
  );
}

export function isReservedRootPath(input: string): boolean {
  return reservedRootPaths.has(input.toLowerCase());
}

export function getCanonicalShortCode(input: unknown): string | undefined {
  if (typeof input !== 'string' || !shortCodePattern.test(input)) return undefined;
  const canonical = input.toLowerCase();
  return isReservedRootPath(canonical) ? undefined : canonical;
}
